// extracted by mini-css-extract-plugin
export default {"articleNumber":"deliveryNoteRows_articleNumber__GUw7D","articleDescription":"deliveryNoteRows_articleDescription__16HEb","cell":"deliveryNoteRows_cell__T+Jcx"};